<template>
  <div class="template-name" v-if="isTemplate">
    <string
      placeholder="Template Name"
      label="Template Name"
      :value="value"
      @setConfigValue="setConfigValue"
      :rules="[{ Type: 'required' }]"
    />
  </div>
</template>
  
  <script>
/**
 * @fileoverview Custom input field for template name
 *
 * @author Cameron Bulock <cameron.bulock@quavo.com>
 */

import string from "@/components/config-field/string";

export default {
  name: "TemplateNameField",
  components: { string },
  props: {
    category: {
      type: String,
    },
    id: {
      type: String,
    },
    value: {
      type: String,
      default: "",
    },
    isTemplate: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    /**
     * Sets the value
     */
    setConfigValue(value) {
      this.$store.dispatch("setConfigValue", {
        ClientInfoRuleId: this.id,
        category: this.category,
        fieldId: "TemplateName",
        value: value.trim(),
      });
    },
  },
};
</script>
  
<style lang="scss" scoped>
.template-name {
  margin-bottom: 24px;
}
</style>